import PropTypes from 'prop-types';
import ToastItem from './ToastItem';

const ToastContainer = ({ toasts, remove }) => {
  return toasts.length === 0 ? undefined : (
    <div className="toast-container position-fixed top-0 end-0 pt-3 pe-3" style={{ zIndex: 1200 }}>
      {toasts.map(({ id, ...toast }) => <ToastItem key={id} onClose={() => remove(id)} {...toast} />)}
    </div>
  );
};
ToastContainer.propTypes = {
  remove: PropTypes.func.isRequired,
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      sticky: PropTypes.bool.isRequired,
      timeout: PropTypes.number.isRequired,
      variant: PropTypes.string.isRequired,
      title: PropTypes.string,
      message: PropTypes.string,
    })
  ).isRequired,
};
export default ToastContainer;
